export default {
  name:"Validations",
  methods: {
    //Funções de mixins devem seguir esse padrão de $_ no nomeamento
    $_checkIfEmailIsValid(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if(!emailRegex.test(email)) {
        this.emailErrors = "Email inválido";
        return false;
      } else {
        this.emailErrors = null;
        return true;
      }
    },
    $_dateFormater(date) {
      try {
        if (date) {
          const part = date.substr(0,10).split('-')
          return new Date(part[0], part[1]-1, part[2]).toLocaleString('pt-br', { year: 'numeric', month: '2-digit', day: '2-digit' })
        } else return ''
      } catch (error) {
        return ''
      }
    }
  }
}